
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/om-oss",
      function () {
        return require("private-next-pages/om-oss/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/om-oss"])
      });
    }
  